/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Repeat_WordsInputs */

const en_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Repeat Words`)
};

const fr_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les mots répétés`)
};

const de_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne doppelte Wörter`)
};

const it_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi le parole ripetute`)
};

const ru_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить повторяющиеся слова`)
};

const es_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar palabras repetidas`)
};

const zh_cn2_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除重复词`)
};

const ja_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複した単語を削除`)
};

const hi_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोहराए गए शब्दों को हटाएँ`)
};

const pt_pt2_remove_repeat_words = /** @type {(inputs: Remove_Repeat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover palavras repetidas`)
};

/**
* | output |
* | --- |
* | "Remove Repeat Words" |
*
* @param {Remove_Repeat_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_repeat_words = /** @type {((inputs?: Remove_Repeat_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Repeat_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_repeat_words(inputs)
	if (locale === "de") return de_remove_repeat_words(inputs)
	if (locale === "it") return it_remove_repeat_words(inputs)
	if (locale === "ru") return ru_remove_repeat_words(inputs)
	if (locale === "es") return es_remove_repeat_words(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_repeat_words(inputs)
	if (locale === "ja") return ja_remove_repeat_words(inputs)
	if (locale === "hi") return hi_remove_repeat_words(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_repeat_words(inputs)
	return en_remove_repeat_words(inputs)
});